import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconGiftBox"><Path d="M2 6.5C2 5.11929 3.11929 4 4.5 4H11.5V9H3.5C2.67157 9 2 8.32843 2 7.5V6.5Z" fill="currentColor"/><Path d="M3 10H11.5V20H5.5C4.11929 20 3 18.8807 3 17.5V10Z" fill="currentColor"/><Path d="M12.5 4H19.5C20.8807 4 22 5.11929 22 6.5V7.5C22 8.32843 21.3284 9 20.5 9H12.5V4Z" fill="currentColor"/><Path d="M12.5 10H21V17.5C21 18.8807 19.8807 20 18.5 20H12.5V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftBox;
